import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MetaData from '../Layouts/MetaData';
import { Box, Container, Typography, Button, Fade } from '@mui/material';
import { CheckCircle, Error } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const OrderSuccess = ({ success }) => {

    const theme = useTheme();
    const navigate = useNavigate();
    const [time, setTime] = useState(3);

    useEffect(() => {
        if (time === 0) {
            if (success) {
                navigate("/orders")
            } else {
                navigate("/cart")
            }
            return;
        };
        const intervalId = setInterval(() => {
            setTime(time - 1);
        }, 1000);

        return () => clearInterval(intervalId);
        // eslint-disable-next-line
    }, [time]);

    return (
        <>
            <MetaData title={`Transaction ${success ? "Successfull" : "Failed"}`} />
            <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
                <Fade in={true}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        bgcolor: 'background.paper',
                        boxShadow: 1,
                        borderRadius: 2,
                        p: 4,
                    }}>
                        {success ? <CheckCircle sx={{ fontSize: 80, color: 'success.main' }} /> : <Error sx={{ fontSize: 80, color: 'error.main' }} />}
                        <Typography variant="h5" component="h1" sx={{ mt: 2, fontWeight: 'bold' }}>
                            Transaction {success ? "Successful" : "Failed"}
                        </Typography>
                        <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary' }}>
                            Redirecting to {success ? "orders" : "cart"} in {time} seconds
                        </Typography>
                        <Button component={Link} to={success ? "/orders" : "/cart"} variant="contained" color="primary" sx={{ mt: 3 }}>
                            Go to {success ? "orders" : "cart"}
                        </Button>
                    </Box>
                </Fade>
            </Container>
        </>
    );
};
export default OrderSuccess;
